"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4828],{

/***/ 57620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913a5.885 5.885 0 0 0 1.384 2.126A5.868 5.868 0 0 0 4.14 23.37c.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558a5.898 5.898 0 0 0 2.126-1.384 5.86 5.86 0 0 0 1.384-2.126c.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913a5.89 5.89 0 0 0-1.384-2.126A5.847 5.847 0 0 0 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227a3.81 3.81 0 0 1-.899 1.382 3.744 3.744 0 0 1-1.38.896c-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421a3.716 3.716 0 0 1-1.379-.899 3.644 3.644 0 0 1-.9-1.38c-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 1 0 0-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 0 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgInstagram);

/***/ }),

/***/ 43441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLinkedin);

/***/ }),

/***/ 66871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "currentColor"
    }
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.954 4.569a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.691 8.094 4.066 6.13 1.64 3.161a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.061a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgTwitter);

/***/ }),

/***/ 53272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/jobsinjs-logo-1.svg
var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgJobsinjsLogo1 = function SvgJobsinjsLogo1(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 269 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 134.5,
    cy: 134.5,
    r: 134.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M82.987 189.904c26.221 0 41.162-14.062 41.162-38.598V82.311H93.095v68.775c0 8.423-3.59 12.817-10.547 12.817-6.885 0-11.353-4.76-11.353-13.183v-.147H41.46v.22c0 24.536 16.186 39.111 41.528 39.111Zm95.622 0c29.151 0 46.143-13.842 46.143-35.669v-.073c0-17.139-10.767-26.367-33.398-30.469l-10.621-1.904c-10.546-1.904-15.087-4.175-15.087-8.935v-.074c0-4.834 4.394-8.569 12.963-8.569 8.496 0 14.649 3.662 15.235 9.448l.073.733h28.564l-.073-1.612c-.879-19.775-15.893-32.373-44.165-32.373-25.049 0-43.359 13.404-43.359 34.644v.073c0 16.406 11.499 27.026 32.519 30.762l10.62 1.904c11.719 2.124 15.967 4.175 15.967 9.155v.074c0 5.273-5.713 9.082-15.014 9.082-8.789 0-15.967-3.809-17.212-9.522l-.147-.659h-28.564l.073 1.392c1.099 20.874 18.091 32.592 45.483 32.592Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var jobsinjs_logo_1 = (SvgJobsinjsLogo1);
// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
;// CONCATENATED MODULE: ./components/Layout/Header/Logo.tsx




const Logo = (param)=>/*#__PURE__*/ {
    let { logoCN  } = param;
    return (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        className: "flex-shrink-0 flex items-center",
        title: "Jobs in JS",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jobsinjs_logo_1, {
            className: (0,classNames/* classNames */.A)("block fill-current", logoCN)
        })
    });
};


/***/ }),

/***/ 71968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PostJobButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43153);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



const PostJobButton = (param)=>/*#__PURE__*/ {
    let { cN , label ="Post job"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/job-posts/create",
        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)("inline-flex items-center px-2 h-10 border border-transparent leading-4 tracking-tight font-medium", cN),
        children: label
    });
};


/***/ }),

/***/ 4828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@auth0/nextjs-auth0/dist/index.browser.js
var index_browser = __webpack_require__(14713);
// EXTERNAL MODULE: ./components/Layout/Header/Logo.tsx + 1 modules
var Logo = __webpack_require__(53272);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
;// CONCATENATED MODULE: ./components/Layout/Header/PrimaryNavigation.tsx




const PrimaryNavigation = ()=>{
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "hidden ml-6 font-medium tracking-tight xl:flex sm:space-x-4 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                className: (0,classNames/* classNames */.A)(router.pathname === "/" ? "text-black" : "text-black", "inline-flex items-center px-1"),
                children: "Find Work"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/hiring",
                className: (0,classNames/* classNames */.A)(router.pathname === "/hiring" ? "text-black" : "text-black", "inline-flex items-center px-1"),
                children: "Hire Devs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/companies",
                className: (0,classNames/* classNames */.A)(router.pathname === "/companies" ? "text-black" : "text-black", "inline-flex items-center px-1"),
                children: "Companies"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Layout/Header/PostJobButton.tsx
var PostJobButton = __webpack_require__(71968);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 7 modules
var menu = __webpack_require__(17657);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/UserCircleIcon.js
var UserCircleIcon = __webpack_require__(55499);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
;// CONCATENATED MODULE: ./components/Layout/Header/SecondaryNavigation.tsx







const MenuButton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
        className: "flex text-sm focus:outline-none",
        title: "menu",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center h-12 -mr-2 pl-2 pr-1 rounded hover:bg-gray-100 lg:h-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCircleIcon/* default */.Z, {
                    className: "block h-8 w-8 text-black sm:h-6 sm:w-6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                    className: "block h-4 w-4 mt-0.5 -ml-1 text-black"
                })
            ]
        })
    });
// Note: The Next.js Link component does not forward unknown props to the underlying a element, so it won't close the menu on click when used inside a Menu.Item.
// To use a Next.js Link inside a Menu.Item, create your own component that wraps Link and forwards unknown props to the child a element.
// https://headlessui.dev/react/menu#integrating-with-next-js
const CustomLink = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    let { href , children , cN ="" , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        ref: ref,
        className: (0,classNames/* classNames */.A)("block px-4 py-2 text-black hover:bg-gray-100", cN),
        ...rest,
        children: children
    });
});
const SecondaryNavigation = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
        as: "div",
        className: "ml-2 relative",
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuButton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: open,
                        as: react.Fragment,
                        enter: "transition ease-out duration-200",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Items */.v.Items, {
                            static: true,
                            className: "origin-top-right fixed right-0 mt-2 left-0 text-lg tracking-tight shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none lg:absolute lg:left-auto lg:w-64 lg:text-sm lg:rounded-md",
                            children: [
                                user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "px-4 py-3 text-xs text-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "",
                                                    children: "Signed in as"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-black truncate",
                                                    title: user.email,
                                                    children: user.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/user",
                                                children: "Dashboard"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/user/job-posts/my",
                                                children: "My job posts"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/user/orders",
                                                children: "Orders"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { active  } = param;
                                                return (0,jsx_runtime.jsx)("a", {
                                                    href: "/api/auth/login",
                                                    className: "block px-4 py-2 font-bold text-black hover:bg-gray-100",
                                                    children: "Sign up"
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: (param)=>/*#__PURE__*/ {
                                                let { active  } = param;
                                                return (0,jsx_runtime.jsx)("a", {
                                                    href: "/api/auth/login",
                                                    className: "block px-4 py-2 text-black hover:bg-gray-100",
                                                    children: "Log in"
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block lg:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/",
                                                children: "Find work"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/hiring",
                                                children: "Hire devs"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/companies",
                                                children: "Companies"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                                href: "/job-posts/create",
                                                cN: "font-bold",
                                                children: "Post a job"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-b"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                                        href: "/about",
                                        children: "About Jobs in JS"
                                    })
                                }),
                                user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: (param)=>/*#__PURE__*/ {
                                            let { active  } = param;
                                            return (0,jsx_runtime.jsx)("a", {
                                                href: "/api/auth/logout",
                                                className: "block px-4 py-2 text-black hover:bg-gray-100",
                                                children: "Log out"
                                            });
                                        }
                                    })
                                }) : null
                            ]
                        })
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./types/misc.ts
var misc = __webpack_require__(19494);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardCommandKey.js
var KeyboardCommandKey = __webpack_require__(44690);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/JobPostSearchModal/HeaderSearch.tsx









const DynamicModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(2720), __webpack_require__.e(6462)]).then(__webpack_require__.bind(__webpack_require__, 96462)).then((mod)=>mod.HeaderSearchModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96462)
            ]
    },
    ssr: false
});
const HeaderSearch = (param)=>{
    let {} = param;
    const router = (0,next_router.useRouter)();
    // Modal.
    const [open, setOpen] = (0,react.useState)(false);
    const theme = (0,useTheme/* default */.Z)();
    const isSmallScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    // Keyboard shortcuts - listen for keys down cmd+k.
    const onKeyDown = (e)=>{
        if (e.metaKey && e.which === 75) {
            setOpen(!open);
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("keydown", onKeyDown);
        return ()=>{
            window.removeEventListener("keydown", onKeyDown);
        };
    });
    // Get search params from url.
    const searchParams = router.query;
    const emptyFormValues = {
        search: "",
        location: "",
        locationType: undefined,
        tags: []
    };
    const formValues = {
        ...emptyFormValues,
        ...searchParams,
        tags: Array.isArray(searchParams.tags) ? searchParams.tags.filter((t)=>!!t) : [
            searchParams.tags
        ].filter((t)=>!!t)
    };
    const { search , location , locationType , tags  } = formValues;
    const numberOfActiveFilters = ()=>{
        let count = 0;
        if (locationType === misc/* LocationType.ONSITE */._i.ONSITE || locationType === misc/* LocationType.REMOTE */._i.REMOTE) {
            count++;
        }
        count += tags.length;
        return count;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                style: {
                    width: isSmallScreen ? 240 : 400
                },
                className: "relative pl-1 pr-16 py-4 text-left text-sm text-gray-400 truncate overflow-hidden rounded-md bg-gray-100 border hover:bg-gray-200 focus-visible:outline-none sm:pr-28",
                onClick: ()=>{
                    setOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                        fontSize: isSmallScreen ? "small" : "medium",
                        className: "-mt-1 ml-1 mr-1 text-gray-400"
                    }),
                    search && location ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-black font-semibold",
                                children: search
                            }),
                            " in ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-black font-semibold",
                                children: location
                            })
                        ]
                    }) : search ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-black font-semibold",
                                children: search
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "anywhere"
                            })
                        ]
                    }) : location ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "",
                                children: "All jobs"
                            }),
                            " in ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-black font-semibold",
                                children: location
                            })
                        ]
                    }) : "Search by title, skill or company...",
                    numberOfActiveFilters() > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute right-2 px-1 uppercase font-semibold tracking-tight text-xxs text-white rounded bg-gray-800 sm:right-10",
                        children: numberOfActiveFilters() === 1 ? "1 filter" : "".concat(numberOfActiveFilters(), " filters")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "hidden absolute right-2 -mt-px p-1 text-xxs text-gray-400 font-medium border border-gray-300 rounded leading-none sm:inline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardCommandKey/* default */.Z, {
                                fontSize: "inherit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "relative top-px",
                                children: "K"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicModal, {
                formValues: formValues,
                emptyFormValues: emptyFormValues,
                open: open,
                setOpen: setOpen
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Layout/Header/Header.tsx






const Header = (param)=>{
    let { user , hasSearch =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex justify-between h-20 items-center px-4 border-b shadowX sm:px-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {
                        logoCN: "h-10 text-[#3333FF] hover:text-[#0000F2]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryNavigation, {})
                ]
            }),
            hasSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 bottom-0 left-0 right-0 z-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSearch, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden ml-3 md:flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostJobButton/* PostJobButton */.b, {
                            cN: "rounded hover:bg-gray-100"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryNavigation, {
                        user: user
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Layout/BodyLayout.tsx


const BodyLayout = (param)=>/*#__PURE__*/ {
    let { children , cN  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classNames/* classNames */.A)("max-w-screen-2xl m-auto mt-8", cN),
        children: children
    });
};

// EXTERNAL MODULE: ./public/social-icons/twitter.svg
var twitter = __webpack_require__(66871);
// EXTERNAL MODULE: ./public/social-icons/linkedin.svg
var linkedin = __webpack_require__(43441);
// EXTERNAL MODULE: ./public/social-icons/instagram.svg
var instagram = __webpack_require__(57620);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(34850);
// EXTERNAL MODULE: ./data/regions.ts
var regions = __webpack_require__(3837);
;// CONCATENATED MODULE: ./data/seoPages/onsite/regions.ts


const regions_regions = [
    {
        path: "/north-america",
        parentPath: "/",
        relatedPaths: regions/* regions.NORTH_AMERICA.countries.map */.U.NORTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in North America in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in North America on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in North America",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.NORTH_AMERICA.countries.map */.U.NORTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.NORTH_AMERICA.countries.map */.U.NORTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    },
    {
        path: "/south-america",
        parentPath: "/",
        relatedPaths: regions/* regions.SOUTH_AMERICA.countries.map */.U.SOUTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in South America in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in South America on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in South America",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.SOUTH_AMERICA.countries.map */.U.SOUTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.SOUTH_AMERICA.countries.map */.U.SOUTH_AMERICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    },
    {
        path: "/europe",
        parentPath: "/",
        relatedPaths: regions/* regions.EUROPE.countries.map */.U.EUROPE.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in Europe in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Europe on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Europe",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.EUROPE.countries.map */.U.EUROPE.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.EUROPE.countries.map */.U.EUROPE.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    },
    {
        path: "/africa",
        parentPath: "/",
        relatedPaths: regions/* regions.ASIA.countries.map */.U.ASIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in Africa in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Africa on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Africa",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.AFRICA.countries.map */.U.AFRICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.AFRICA.countries.map */.U.AFRICA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    },
    {
        path: "/asia",
        parentPath: "/",
        relatedPaths: regions/* regions.ASIA.countries.map */.U.ASIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in Asia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Asia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Asia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.ASIA.countries.map */.U.ASIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.ASIA.countries.map */.U.ASIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    },
    {
        path: "/oceania",
        parentPath: "/",
        relatedPaths: regions/* regions.OCEANIA.countries.map */.U.OCEANIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())),
        page: {
            header: {
                title: "JavaScript jobs in Oceania in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Oceania on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Oceania",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: regions/* regions.OCEANIA.countries.map */.U.OCEANIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: regions/* regions.OCEANIA.countries.map */.U.OCEANIA.countries.map((country)=>"country_code:".concat(country.toLowerCase())).join(", "),
            remoteLocationTagsMinimumMatch: 1
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/eu.ts

const eu = [
    {
        path: "/eu",
        parentPath: "/",
        relatedPaths: [
            "/remote/eu"
        ],
        page: {
            header: {
                title: "JavaScript jobs in the European Union in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in the European Union on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in the European Union",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:at, country_code:be, country_code:bg, country_code:cy, country_code:cz, country_code:de, country_code:dk, country_code:ee, country_code:es, country_code:fi, country_code:fr, country_code:gr, country_code:hr, country_code:hu, country_code:ie, country_code:it, country_code:lt, country_code:lu, country_code:lv, country_code:mt, country_code:nl, country_code:pl, country_code:pt, country_code:ro, country_code:se, country_code:si, country_code:sk",
            onsiteLocationTagsMinimumMatch: 1,
            remoteLocationTags: "country_code:at, country_code:be, country_code:bg, country_code:cy, country_code:cz, country_code:de, country_code:dk, country_code:ee, country_code:es, country_code:fi, country_code:fr, country_code:gr, country_code:hr, country_code:hu, country_code:ie, country_code:it, country_code:lt, country_code:lu, country_code:lv, country_code:mt, country_code:nl, country_code:pl, country_code:pt, country_code:ro, country_code:se, country_code:si, country_code:sk",
            remoteLocationTagsMinimumMatch: 1
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/fr.ts

const fr = [
    {
        path: "/fr",
        parentPath: "/",
        relatedPaths: [
            "/remote/fr"
        ],
        page: {
            header: {
                title: "JavaScript jobs in France in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in France on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in France",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:fr",
            remoteLocationTags: "country_code:fr"
        }
    },
    {
        path: "/fr/paris",
        parentPath: "/fr",
        relatedPaths: [
            "/remote/fr"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Paris, France in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Paris, France on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Paris, France",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:fr, locality_long_name:paris",
            remoteLocationTags: "country_code:fr"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/ca.ts

const ca = [
    {
        path: "/ca",
        parentPath: "/",
        relatedPaths: [
            "/remote/ca"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Canada in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Canada on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Canada",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:ca",
            remoteLocationTags: "country_code:ca"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/es.ts

const es = [
    {
        path: "/es",
        parentPath: "/",
        relatedPaths: [
            "/remote/es"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Spain in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Spain on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Spain",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:es",
            remoteLocationTags: "country_code:es"
        }
    },
    {
        path: "/es/barcelona",
        parentPath: "/es",
        relatedPaths: [
            "/es/madrid",
            "/remote/es"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Barcelona, Spain in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Barcelona, Spain on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Barcelona, Spain",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:es, locality_long_name:barcelona",
            remoteLocationTags: "country_code:es"
        }
    },
    {
        path: "/es/madrid",
        parentPath: "/es",
        relatedPaths: [
            "/es/barcelona",
            "/remote/es"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Madrid, Spain in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Madrid, Spain on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Madrid, Spain",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:es, locality_long_name:madrid",
            remoteLocationTags: "country_code:es"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/uk.ts

const uk = [
    {
        path: "/uk",
        parentPath: "/",
        relatedPaths: [
            "/remote/uk"
        ],
        page: {
            header: {
                title: "JavaScript jobs in the United Kingdom in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in the United Kingdom on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in the United Kingdom",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:gb",
            remoteLocationTags: "country_code:gb"
        }
    },
    {
        path: "/uk/london",
        parentPath: "/uk",
        relatedPaths: [
            "/remote/uk"
        ],
        page: {
            header: {
                title: "JavaScript jobs in London, UK in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in London, UK on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in London, UK",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:gb, locality_long_name:london",
            remoteLocationTags: "country_code:gb"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/us.ts

const us = [
    {
        path: "/us",
        parentPath: "/",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in the United States in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in the United States on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in the United States",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/san-francisco",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us",
            "/us/los-angeles",
            "/us/new-york"
        ],
        page: {
            header: {
                title: "JavaScript jobs in San Francisco, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in San Francisco, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in San Francisco, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:san francisco",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/los-angeles",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Los Angeles, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Los Angeles, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Los Angeles, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:los angeles",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/new-york",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in New York, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in New York, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in New York, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:new york",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/austin",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Austin, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Austin, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Austin, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:austin",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/miami",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Miami, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Miami, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Miami, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:miami",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/seattle",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Seattle, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Seattle, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Seattle, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:seattle",
            remoteLocationTags: "country_code:us"
        }
    },
    {
        path: "/us/chicago",
        parentPath: "/us",
        relatedPaths: [
            "/remote/us"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Chicago, USA in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Chicago, USA on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Chicago, USA",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:us, locality_long_name:chicago",
            remoteLocationTags: "country_code:us"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/de.ts

const de = [
    {
        path: "/de",
        parentPath: "/",
        relatedPaths: [
            "/remote/de"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Germany in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Germany on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Germany",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:de"
        }
    },
    {
        path: "/de/berlin",
        parentPath: "/de",
        relatedPaths: [
            "/de/frankfurt",
            "/remote/de"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Berlin, Germany in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Berlin, Germany on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Berlin, Germany",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:de, locality_long_name:berlin",
            remoteLocationTags: "country_code:de"
        }
    },
    {
        path: "/de/frankfurt",
        parentPath: "/de",
        relatedPaths: [
            "/de/berlin",
            "/remote/de"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Frankfurt, Germany in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Frankfurt, Germany on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Frankfurt, Germany",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:de, locality_long_name:frankfurt",
            remoteLocationTags: "country_code:de"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/au.ts

const au = [
    {
        path: "/au",
        parentPath: "/",
        relatedPaths: [
            "/au/sydney",
            "/au/melbourne",
            "/remote/au"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Australia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Australia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Australia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:au",
            remoteLocationTags: "country_code:au"
        }
    },
    {
        path: "/au/sydney",
        parentPath: "/au",
        relatedPaths: [
            "/au/melbourne",
            "/remote/au"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Sydney, Australia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Sydney, Australia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Sydney, Australia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:au, locality_long_name:sydney",
            remoteLocationTags: "country_code:au"
        }
    },
    {
        path: "/au/melbourne",
        parentPath: "/au",
        relatedPaths: [
            "/au/sydney",
            "/remote/au"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Melbourne, Australia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Melbourne, Australia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Melbourne, Australia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:au, locality_long_name:melbourne",
            remoteLocationTags: "country_code:au"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/pt.ts

const pt = [
    {
        path: "/pt",
        parentPath: "/",
        relatedPaths: [
            "/remote/pt"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Portugal in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Portugal on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Portugal",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:pt",
            remoteLocationTags: "country_code:pt"
        }
    },
    {
        path: "/pt/lisbon",
        parentPath: "/pt",
        relatedPaths: [
            "/pt/porto",
            "/remote/pt"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Lisbon, Portugal in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Lisbon, Portugal on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Lisbon, Portugal",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:pt, locality_long_name:lisbon",
            remoteLocationTags: "country_code:pt"
        }
    },
    {
        path: "/pt/porto",
        parentPath: "/pt",
        relatedPaths: [
            "/pt/lisbon",
            "/remote/pt"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Porto, Portugal in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Porto, Portugal on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Porto, Portugal",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:pt, locality_long_name:porto",
            remoteLocationTags: "country_code:pt"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/it.ts

const it = [
    {
        path: "/it",
        parentPath: "/",
        relatedPaths: [
            "/remote/it"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Italy in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Italy on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Italy",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:it",
            remoteLocationTags: "country_code:it"
        }
    },
    {
        path: "/it/rome",
        parentPath: "/it",
        relatedPaths: [
            "/remote/it"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Rome, Italy in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Rome, Italy on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Rome, Italy",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:it, locality_long_name:rome",
            remoteLocationTags: "country_code:it"
        }
    },
    {
        path: "/it/milan",
        parentPath: "/it",
        relatedPaths: [
            "/remote/it"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Milan, Italy in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Milan, Italy on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Milan, Italy",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:it, locality_long_name:milan",
            remoteLocationTags: "country_code:it"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/be.ts

const be = [
    {
        path: "/be",
        parentPath: "/",
        relatedPaths: [
            "/remote/be"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Belgium in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Belgium on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Belgium",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:be",
            remoteLocationTags: "country_code:be"
        }
    },
    {
        path: "/be/brussels",
        parentPath: "/be",
        relatedPaths: [
            "/remote/be"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Brussels, Belgium in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Brussels, Belgium on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Brussels, Belgium",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:be, locality_long_name:brussels",
            remoteLocationTags: "country_code:be"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite/cz.ts

const cz = [
    {
        path: "/cz",
        parentPath: "/",
        relatedPaths: [
            "/cz/prague",
            "/cz/brno",
            "/remote/cz"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Czechia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Czechia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Czechia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:cz",
            remoteLocationTags: "country_code:cz"
        }
    },
    {
        path: "/cz/prague",
        parentPath: "/cz",
        relatedPaths: [
            "/cz/brno",
            "/remote/cz"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Prague, Czechia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Prague, Czechia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Prague, Czechia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:cz, locality_long_name:prague",
            remoteLocationTags: "country_code:cz"
        }
    },
    {
        path: "/cz/brno",
        parentPath: "/cz",
        relatedPaths: [
            "/cz/prague",
            "/remote/cz"
        ],
        page: {
            header: {
                title: "JavaScript jobs in Brno, Czechia in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring in Brno, Czechia on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs hiring in Brno, Czechia",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            onsiteLocationTags: "country_code:cz, locality_long_name:brno",
            remoteLocationTags: "country_code:cz"
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/onsite.ts













const onsite = [
    ...regions_regions,
    ...us,
    ...ca,
    ...eu,
    ...uk,
    ...es,
    ...pt,
    ...fr,
    ...it,
    ...de,
    ...au,
    ...be,
    ...cz
];

;// CONCATENATED MODULE: ./data/seoPages/general.tsx

const general = [
    {
        path: "/",
        parentPath: undefined,
        relatedPaths: [],
        maxRelatedPages: 10,
        page: {
            header: {
                title: "JavaScript jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Javascript Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Top JavaScript Jobs Worldwide",
                subHeading: "Job board made and curated by JavaScript developers"
            }
        },
        query: {}
    },
    {
        path: "/junior-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Junior developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Junior Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Junior JavaScript Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "junior-level"
            ]
        }
    },
    {
        path: "/mid-level-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Mid-weight developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Mid-weight Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Mid-weight JavaScript Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "mid-level"
            ]
        }
    },
    {
        path: "/senior-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Senior developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Senior Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Senior JavaScript Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "senior-level"
            ]
        }
    },
    {
        path: "/front-end-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Front End jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Front End Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Front End Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "front-end"
            ]
        }
    },
    {
        path: "/senior-front-end-developer-jobs",
        parentPath: "/front-end-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Senior Front End Developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Senior Front End Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Senior Front End Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "front-end",
                "senior-level"
            ]
        }
    },
    {
        path: "/junior-front-end-developer-jobs",
        parentPath: "/front-end-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Junior Front End Developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Junior Front End Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Junior Front End Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "front-end",
                "junior-level"
            ]
        }
    },
    {
        path: "/full-stack-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Full Stack developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Full Stack Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Full Stack Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "full-stack"
            ]
        }
    },
    {
        path: "/senior-full-stack-developer-jobs",
        parentPath: "/full-stack-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Senior Full Stack developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Senior Full Stack Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Senior Full Stack Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "full-stack",
                "senior-level"
            ]
        }
    },
    {
        path: "/react-developer-jobs",
        parentPath: "/front-end-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "React developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to React Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "React Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "react"
            ]
        }
    },
    {
        path: "/senior-react-developer-jobs",
        parentPath: "/react-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Senior React developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Senior React Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Senior React Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "react",
                "senior-level"
            ]
        }
    },
    {
        path: "/react-native-developer-jobs",
        parentPath: "/react-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "React Native developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to React Native Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "React Native Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "react-native"
            ]
        }
    },
    {
        path: "/typescript-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "TypeScript developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to TypeScript Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "TypeScript Jobs Worldwide",
                subHeading: "Curated by TypeScript developers"
            }
        },
        query: {
            tags: [
                "typescript"
            ]
        }
    },
    {
        path: "/node-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Node.js developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Node.js Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Node.js Jobs Worldwide",
                subHeading: "Curated by TypeScript developers"
            }
        },
        query: {
            tags: [
                "node"
            ]
        }
    },
    {
        path: "/back-end-developer-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Back End developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Back End Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Back End Jobs Worldwide",
                subHeading: "Curated by TypeScript developers"
            }
        },
        query: {
            tags: [
                "back-end"
            ]
        }
    },
    {
        path: "/angular-developer-jobs",
        parentPath: "/front-end-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Angular developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Angular Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Angular Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "angular"
            ]
        }
    },
    {
        path: "/vue-developer-jobs",
        parentPath: "/front-end-developer-jobs",
        relatedPaths: [],
        page: {
            header: {
                title: "Vue.js developer jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Vue.js Developer jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Vue.js Jobs Worldwide",
                subHeading: "Curated by JavaScript developers"
            }
        },
        query: {
            tags: [
                "vue"
            ]
        }
    }
];

;// CONCATENATED MODULE: ./data/seoPages/collections.tsx

const collections = [
    {
        path: "/aerospace-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Aerospace jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Aerospace jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Aerospace companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "aerospace"
            ]
        }
    },
    {
        path: "/automotive-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Automotive jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Automotive jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Automotive companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "automotive"
            ]
        }
    },
    {
        path: "/blockchain-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Blockchain jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Blockchain jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Blockchain companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "blockchain"
            ]
        }
    },
    {
        path: "/creative-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Creative jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Creative jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Creative companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "creative"
            ]
        }
    },
    {
        path: "/crypto-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Cryptocurrency jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Cryptocurrency jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Cryptocurrency companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "crypto"
            ]
        }
    },
    {
        path: "/data-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Data jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Data jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Data companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "data"
            ]
        }
    },
    {
        path: "/developer-tools-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Developer Tools jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Developer Tools jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Developer Tools companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "developer-tools"
            ]
        }
    },
    {
        path: "/finance-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Finance jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Finance jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Finance companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "finance"
            ]
        }
    },
    {
        path: "/fashion-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Fashion jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Fashion jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Fashion companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "fashion"
            ]
        }
    },
    {
        path: "/gaming-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Gaming jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Gaming jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Gaming companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "games"
            ]
        }
    },
    {
        path: "/healthcare-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Healthcare jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Healthcare jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Healthcare companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "healthcare"
            ]
        }
    },
    {
        path: "/human-resources-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Human Resources jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Human Resources jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Human Resources companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "human-resources"
            ]
        }
    },
    {
        path: "/marketing-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Marketing jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Marketing jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Marketing companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "marketing"
            ]
        }
    },
    {
        path: "/media-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Media jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Media jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Media companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "media"
            ]
        }
    },
    {
        path: "/metaverse-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Metaverse jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Metaverse jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Metaverse companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "metaverse"
            ]
        }
    },
    {
        path: "/music-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Music jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Music jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Music companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "music"
            ]
        }
    },
    {
        path: "/nft-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "NFT jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to NFT jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "NFT companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "nft"
            ]
        }
    },
    {
        path: "/no-code-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "No-Code jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to No-Code jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "No-Code companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "no-code"
            ]
        }
    },
    {
        path: "/non-profit-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Non-Profit jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Non-Profit jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Non-Profit organisations hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "non-profit"
            ]
        }
    },
    {
        path: "/productivity-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Productivity jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Productivity jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Productivity companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "productivity"
            ]
        }
    },
    {
        path: "/real-estate-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Real Estate jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Real Estate jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Real Estate companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "real-estate"
            ]
        }
    },
    {
        path: "/retail-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Retail jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Retail jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Retail companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "retail"
            ]
        }
    },
    {
        path: "/robotics-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Robotics jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Robotics jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Robotics companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "robotics"
            ]
        }
    },
    {
        path: "/saas-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "SaaS jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to SaaS jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "SaaS companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "saas"
            ]
        }
    },
    {
        path: "/security-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Security jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Security jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Security companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "security"
            ]
        }
    },
    {
        path: "/social-media-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Social Media jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Social Media jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Social Media companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "social-media"
            ]
        }
    },
    {
        path: "/software-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Software jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Software jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Software companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "software"
            ]
        }
    },
    {
        path: "/sports-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Sports jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Sports jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Sports companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "sports"
            ]
        }
    },
    {
        path: "/sustainability-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Sustainability jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Sustainability jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Sustainability companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "sustainability"
            ]
        }
    },
    {
        path: "/tech-for-good-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Tech-for-Good jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Tech-for-Good jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Tech-for-Good companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "tech-for-good"
            ]
        }
    },
    {
        path: "/telecomunication-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Telecomunication jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Telecomunication jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Telecomunication companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "telecomunication"
            ]
        }
    },
    {
        path: "/transportation-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Transportation jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Transportation jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Transportation companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "transportation"
            ]
        }
    },
    {
        path: "/travel-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "Travel jobs in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to Travel jobs now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "Travel companies hiring JavaScript developers",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "travel"
            ]
        }
    },
    {
        path: "/visa-sponsorship-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "JavaScript jobs providing visa sponsorship in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to JavaScript jobs providing visa sponsorship now hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "JavaScript jobs providing visa sponsorship",
                subHeading: "Curated by JavaScript developers."
            }
        },
        query: {
            tags: [
                "visa-sponsorship"
            ]
        }
    },
    {
        path: "/4-day-week-jobs",
        parentPath: "/",
        relatedPaths: [],
        page: {
            header: {
                title: "4 day work week JavaScript jobs hiring in ".concat((0,format/* default */.Z)(new Date(), "LLLL yyyy"), " | JobsinJS.com"),
                description: "Apply to 4 day work week JavaScript jobs hiring on JobsinJS.com, the worlds largest JavaScript job site."
            },
            body: {
                heading: "4 day week jobs hiring JavaScript developers",
                subHeading: "Find jobs with a 4 day work week (mostly 32hrs)"
            }
        },
        query: {
            tags: [
                "4-day-week"
            ]
        }
    }
];

;// CONCATENATED MODULE: ./components/Layout/Footer.tsx









const FooterLink = (param)=>/*#__PURE__*/ {
    let { href , children  } = param;
    return (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        className: "block text-gray-400 hover:text-gray-500",
        children: children
    });
};
// capitalize first letter in string
const capitalize = (s)=>{
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};
const Footer = ()=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "mt-20 pt-10 pb-20 border-t",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-3xl mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-between mb-10 text-xs leading-6 sm:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-4 my-4 space-y-1.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-medium uppercase",
                                    children: "Categories"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: general.map((seoPage)=>{
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                                href: seoPage.path,
                                                children: (ref = seoPage.page.body.heading) === null || ref === void 0 ? void 0 : ref.replace("hiring around the World", "")
                                            })
                                        }, seoPage.path);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-4 my-4 space-y-1.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-medium uppercase",
                                    children: "Locations"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: onsite.map((seoPage)=>{
                                        var ref, ref1;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                                href: seoPage.path,
                                                children: (ref1 = (ref = seoPage.page.body.heading) === null || ref === void 0 ? void 0 : ref.replace("JavaScript jobs hiring in the", "")) === null || ref1 === void 0 ? void 0 : ref1.replace("JavaScript jobs hiring in", "")
                                            }, seoPage.path)
                                        }, seoPage.path);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-4 my-4 space-y-1.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-medium uppercase",
                                    children: "Collections"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: collections.map((seoPage)=>{
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                                href: seoPage.path,
                                                children: capitalize((ref = seoPage.page.body.heading) === null || ref === void 0 ? void 0 : ref.replace("hiring JavaScript developers", "").replace("JavaScript", "").trim())
                                            })
                                        }, seoPage.path);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-4 my-4 space-y-1.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-medium uppercase",
                                    children: "General"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                    href: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                    href: "/hiring",
                                    children: "Hire JavaScript Developers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                    href: "/job-posts/create",
                                    children: "Post your job"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                    href: "/about",
                                    children: "About"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row justify-center mx-auto my-4 space-x-4 text-xs text-gray-300 ",
                    children: "\xa9 2019-2022 JobsinJS.com. All Rights Reserved."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-center mx-auto space-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://twitter.com/jobsinjs",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter/* default */.Z, {
                                className: "fill-current text-gray-200 hover:text-gray-400 h-6",
                                title: "Twitter"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.linkedin.com/company/jobs-in-js/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin/* default */.Z, {
                                className: "fill-current text-gray-200 hover:text-gray-400 h-6",
                                title: "LinkedIn"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.instagram.com/jobsinjs/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagram/* default */.Z, {
                                className: "fill-current text-gray-200 hover:text-gray-400 h-6",
                                title: "Instagram"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-10 text-center ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xs text-gray-300",
                            children: "More projects by me"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://czechcourse.com/",
                            className: "text-blue-600 hover:text-blue-700",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Czech Course"
                                }),
                                ": Learn Czech language online"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Layout/Layout.tsx







const Layout = (param)=>{
    let { pageTitle , metaDescription , canonicalUrl , hasRobotsNoIndex , children , bodyCN , hasSearch  } = param;
    // Auth0
    const { user , error , isLoading  } = (0,index_browser/* useUser */.aF)();
    // if (isLoading) return <div>Loading...</div>;
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: error.message
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: pageTitle
                    }),
                    metaDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    hasRobotsNoIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-analytics",
                strategy: "afterInteractive",
                children: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){window.dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', '".concat("G-TZWE5D9V15", "');\n        ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://www.googletagmanager.com/gtag/js?id=".concat("G-TZWE5D9V15"),
                strategy: "lazyOnload"
            }),
             true && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "min-h-screen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed top-0 left-0 z-50 w-full h-20 bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                            user: user,
                            hasSearch: hasSearch
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyLayout, {
                            cN: bodyCN,
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 3837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ regions; },
/* harmony export */   "W": function() { return /* binding */ timeZones; }
/* harmony export */ });
const regions = {
    ASIA: {
        name: "Asia",
        countries: [
            "AE",
            "AF",
            "AM",
            "AZ",
            "BD",
            "BH",
            "BN",
            "BT",
            "CC",
            "CN",
            "CX",
            "GE",
            "HK",
            "ID",
            "IL",
            "IN",
            "IO",
            "IQ",
            "IR",
            "JO",
            "JP",
            "KG",
            "KH",
            "KP",
            "KR",
            "KW",
            "KZ",
            "LA",
            "LB",
            "LK",
            "MM",
            "MN",
            "MO",
            "MV",
            "MY",
            "NP",
            "OM",
            "PH",
            "PK",
            "PS",
            "QA",
            "SA",
            "SG",
            "SY",
            "TH",
            "TJ",
            "TM",
            "TR",
            "TW",
            "UZ",
            "VN",
            "YE"
        ]
    },
    OCEANIA: {
        name: "Oceania",
        countries: [
            "AS",
            "AU",
            "CK",
            "FJ",
            "FM",
            "GU",
            "KI",
            "MH",
            "MP",
            "NC",
            "NF",
            "NR",
            "NU",
            "NZ",
            "PF",
            "PG",
            "PN",
            "PW",
            "SB",
            "TK",
            "TL",
            "TO",
            "TV",
            "UM",
            "VU",
            "WF",
            "WS"
        ]
    },
    AFRICA: {
        name: "Africa",
        countries: [
            "AO",
            "BF",
            "BI",
            "BJ",
            "BW",
            "CD",
            "CF",
            "CG",
            "CI",
            "CM",
            "CV",
            "DJ",
            "DZ",
            "EG",
            "EH",
            "ER",
            "ET",
            "GA",
            "GH",
            "GM",
            "GN",
            "GQ",
            "GW",
            "KE",
            "KM",
            "LR",
            "LS",
            "LY",
            "MA",
            "MG",
            "ML",
            "MR",
            "MU",
            "MW",
            "MZ",
            "NA",
            "NE",
            "NG",
            "RE",
            "RW",
            "SC",
            "SD",
            "SH",
            "SL",
            "SN",
            "SO",
            "SS",
            "ST",
            "SZ",
            "TD",
            "TG",
            "TN",
            "TZ",
            "UG",
            "YT",
            "ZA",
            "ZM",
            "ZW"
        ]
    },
    EUROPE: {
        name: "Europe",
        countries: [
            "AD",
            "AL",
            "AT",
            "AX",
            "BA",
            "BE",
            "BG",
            "BY",
            "CH",
            "CY",
            "CZ",
            "DE",
            "DK",
            "EE",
            "ES",
            "FI",
            "FO",
            "FR",
            "GB",
            "GG",
            "GI",
            "GR",
            "HR",
            "HU",
            "IE",
            "IM",
            "IS",
            "IT",
            "JE",
            "LI",
            "LT",
            "LU",
            "LV",
            "MC",
            "MD",
            "ME",
            "MK",
            "MT",
            "NL",
            "NO",
            "PL",
            "PT",
            "RO",
            "RS",
            "RU",
            "SE",
            "SI",
            "SJ",
            "SK",
            "SM",
            "UA",
            "VA",
            "XK"
        ]
    },
    EUROPEAN_UNION: {
        name: "European Union",
        countries: [
            "AT",
            "BE",
            "BG",
            "CY",
            "CZ",
            "DE",
            "DK",
            "EE",
            "ES",
            "FI",
            "FR",
            "GR",
            "HR",
            "HU",
            "IE",
            "IT",
            "LT",
            "LU",
            "LV",
            "MT",
            "NL",
            "PL",
            "PT",
            "RO",
            "SE",
            "SI",
            "SK"
        ]
    },
    NORTH_AMERICA: {
        name: "North America",
        countries: [
            "AG",
            "AI",
            "AW",
            "BB",
            "BL",
            "BM",
            "BQ",
            "BS",
            "BZ",
            "CA",
            "CR",
            "CU",
            "CW",
            "DM",
            "DO",
            "GD",
            "GL",
            "GP",
            "GT",
            "HN",
            "HT",
            "JM",
            "KN",
            "KY",
            "LC",
            "MF",
            "MQ",
            "MS",
            "MX",
            "NI",
            "PA",
            "PM",
            "PR",
            "SV",
            "SX",
            "TC",
            "TT",
            "US",
            "VC",
            "VG",
            "VI"
        ]
    },
    SOUTH_AMERICA: {
        name: "South America",
        countries: [
            "AR",
            "BO",
            "BR",
            "CL",
            "CO",
            "EC",
            "FK",
            "GF",
            "GY",
            "PE",
            "PY",
            "SR",
            "UY",
            "VE"
        ]
    },
    get AMERICAS () {
        return {
            name: "Americas",
            countries: [
                ...this.NORTH_AMERICA.countries,
                ...this.SOUTH_AMERICA.countries
            ]
        };
    }
};
const timeZones = {
    "UTC-11": {
        countries: [
            "NU",
            "AS",
            "UM"
        ]
    },
    "UTC-10": {
        countries: [
            "US",
            "UM",
            "CK",
            "PF"
        ]
    },
    "UTC-9": {
        countries: [
            "US",
            "PF"
        ]
    },
    "UTC-8": {
        countries: [
            "US",
            "MX",
            "CA",
            "PN"
        ]
    },
    "UTC-7": {
        countries: [
            "US",
            "CA",
            "MX"
        ]
    },
    "UTC-6": {
        countries: [
            "MX",
            "BZ",
            "US",
            "CR",
            "SV",
            "GT",
            "NI",
            "CA",
            "HN",
            "CL",
            "EC"
        ]
    },
    "UTC-5": {
        countries: [
            "CO",
            "MX",
            "US",
            "BR",
            "TC",
            "EC",
            "CU",
            "CA",
            "JM",
            "PE",
            "PA",
            "KY",
            "HT",
            "BS"
        ]
    },
    "UTC-4": {
        countries: [
            "PY",
            "BB",
            "BR",
            "VE",
            "CA",
            "GY",
            "BO",
            "MQ",
            "PR",
            "AG",
            "AI",
            "AW",
            "BL",
            "BQ",
            "CW",
            "DM",
            "GD",
            "GP",
            "KN",
            "LC",
            "MF",
            "MS",
            "SX",
            "TT",
            "VC",
            "VG",
            "VI",
            "CL",
            "DO",
            "GL",
            "BM"
        ]
    },
    "UTC-3": {
        countries: [
            "BR",
            "AR",
            "GF",
            "PM",
            "UY",
            "GL",
            "SR",
            "CL",
            "AQ",
            "FK"
        ]
    },
    "UTC-2": {
        countries: [
            "BR",
            "GS"
        ]
    },
    "UTC-1": {
        countries: [
            "GL",
            "PT",
            "CV"
        ]
    },
    UTC: {
        countries: [
            "CI",
            "BF",
            "GH",
            "GM",
            "GN",
            "ML",
            "MR",
            "SH",
            "SL",
            "SN",
            "TG",
            "GW",
            "LR",
            "ST",
            "GL",
            "AQ",
            "ES",
            "FO",
            "PT",
            "IS",
            "GB",
            "GG",
            "IM",
            "JE"
        ]
    },
    "UTC+1": {
        countries: [
            "DZ",
            "MA",
            "ES",
            "EH",
            "NG",
            "AO",
            "BJ",
            "CD",
            "CF",
            "CG",
            "CM",
            "GA",
            "GQ",
            "NE",
            "TD",
            "TN",
            "NL",
            "AD",
            "RS",
            "BA",
            "HR",
            "ME",
            "MK",
            "SI",
            "DE",
            "BE",
            "HU",
            "DK",
            "IE",
            "GI",
            "LU",
            "MT",
            "MC",
            "NO",
            "SJ",
            "BV",
            "FR",
            "CZ",
            "SK",
            "IT",
            "SM",
            "VA",
            "SE",
            "AL",
            "AT",
            "PL",
            "CH",
            "LI"
        ]
    },
    "UTC+2": {
        countries: [
            "EG",
            "ZA",
            "LS",
            "SZ",
            "SS",
            "SD",
            "MZ",
            "BI",
            "BW",
            "CD",
            "MW",
            "RW",
            "ZM",
            "ZW",
            "LY",
            "NA",
            "JO",
            "LB",
            "SY",
            "CY",
            "PS",
            "IL",
            "GR",
            "RO",
            "MD",
            "FI",
            "AX",
            "RU",
            "UA",
            "LV",
            "BG",
            "EE",
            "LT"
        ]
    },
    "UTC+3": {
        countries: [
            "KE",
            "DJ",
            "ER",
            "ET",
            "KM",
            "MG",
            "SO",
            "TZ",
            "UG",
            "YT",
            "IQ",
            "QA",
            "BH",
            "SA",
            "AQ",
            "KW",
            "YE",
            "TR",
            "RU",
            "BY",
            "UA"
        ]
    },
    "UTC+4": {
        countries: [
            "AZ",
            "AE",
            "OM",
            "GE",
            "AM",
            "RU",
            "SC",
            "MU",
            "RE",
            "TF"
        ]
    },
    "UTC+5": {
        countries: [
            "AQ",
            "KZ",
            "TM",
            "TJ",
            "PK",
            "UZ",
            "RU",
            "TF",
            "HM",
            "MV"
        ]
    },
    "UTC+6": {
        countries: [
            "AQ",
            "KZ",
            "KG",
            "BD",
            "RU",
            "BT",
            "CN",
            "IO"
        ]
    },
    "UTC+7": {
        countries: [
            "AQ",
            "TH",
            "KH",
            "LA",
            "VN",
            "RU",
            "MN",
            "ID",
            "CX"
        ]
    },
    "UTC+8": {
        countries: [
            "BN",
            "MN",
            "HK",
            "RU",
            "MY",
            "MO",
            "ID",
            "PH",
            "CN",
            "SG",
            "TW",
            "AU"
        ]
    },
    "UTC+9": {
        countries: [
            "RU",
            "TL",
            "ID",
            "KP",
            "KR",
            "JP",
            "PW"
        ]
    },
    "UTC+10": {
        countries: [
            "AU",
            "RU",
            "FM",
            "GU",
            "MP",
            "PG",
            "AQ"
        ]
    },
    "UTC+11": {
        countries: [
            "AQ",
            "RU",
            "PG",
            "VU",
            "SB",
            "FM",
            "NF",
            "NC"
        ]
    },
    "UTC+12": {
        countries: [
            "RU",
            "NZ",
            "AQ",
            "FJ",
            "TV",
            "MH",
            "NR",
            "KI",
            "UM",
            "WF"
        ]
    },
    "UTC+13": {
        countries: [
            "WS",
            "TK",
            "KI",
            "TO"
        ]
    },
    "UTC+14": {
        countries: [
            "KI"
        ]
    }
};


/***/ }),

/***/ 19494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_i": function() { return /* binding */ LocationType; }
/* harmony export */ });
/* unused harmony exports SiteId, UserType, ProductType, ActionType, Ir35Status, Page, ActionStatus */
var SiteId;
(function(SiteId) {
    SiteId["JobsInJsCom"] = "JobsInJsCom";
    SiteId["GoogleCom"] = "GoogleCom";
    SiteId["LinkedInCom"] = "LinkedInCom";
    SiteId["IndeedCom"] = "IndeedCom";
    SiteId["AngelListCo"] = "AngelListCo";
    SiteId["TotalJobsCom"] = "TotalJobsCom";
    SiteId["CvLibraryCoUk"] = "CvLibraryCoUk";
    SiteId["HireRemoteIo"] = "HireRemoteIo";
    SiteId["WeWorkRemotelyCom"] = "WeWorkRemotelyCom";
    SiteId["WorkInStartupsCom"] = "WorkInStartupsCom";
    SiteId["ReedCoUk"] = "ReedCoUk";
    SiteId["EFinancialCareersCoUk"] = "EFinancialCareersCoUk";
    SiteId["TechnoJobsCoUk"] = "TechnoJobsCoUk";
    SiteId["JobServeCom"] = "JobServeCom";
})(SiteId || (SiteId = {}));
var UserType;
(function(UserType) {
    UserType["JobsInJsComBot"] = "JobsInJsComBot";
    UserType["JobsInJsComCrawler"] = "JobsInJsComCrawler";
    UserType["JobsInJsComEditor"] = "JobsInJsComEditor";
    UserType["JobsInJsComUser"] = "JobsInJsComUser";
})(UserType || (UserType = {}));
var ProductType;
(function(ProductType) {
    ProductType["NewListing"] = "NewListing";
    ProductType["ListingPromotion"] = "ListingPromotion";
})(ProductType || (ProductType = {}));
var ActionType;
(function(ActionType) {
    ActionType["CreateJob"] = "CreateJob";
    ActionType["CreateJobPaymentSuccessful"] = "CreateJobPaymentSuccessful";
    ActionType["PromoteJob"] = "PromoteJob";
})(ActionType || (ActionType = {}));
var Ir35Status;
(function(Ir35Status) {
    Ir35Status["Inside"] = "Inside";
    Ir35Status["Outside"] = "Outside";
})(Ir35Status || (Ir35Status = {}));
var Page;
(function(Page) {
    Page["JobDoesNotExist"] = "JobDoesNotExist";
    Page["JobNoLongerAvailable"] = "JobNoLongerAvailable";
    Page["PageNotFound"] = "PageNotFound";
    Page["PostNewJob"] = "PostNewJob";
})(Page || (Page = {}));
var ActionStatus;
(function(ActionStatus) {
    ActionStatus["Success"] = "Success";
    ActionStatus["Error"] = "Error";
})(ActionStatus || (ActionStatus = {}));
var LocationType;
(function(LocationType) {
    LocationType["ONSITE"] = "ONSITE";
    LocationType["ONSITE_AND_REMOTE"] = "ONSITE_AND_REMOTE";
    LocationType["REMOTE"] = "REMOTE";
})(LocationType || (LocationType = {}));


/***/ }),

/***/ 43153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ classNames; }
/* harmony export */ });
const classNames = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
};


/***/ })

}]);